import { render, staticRenderFns } from "./EventsBestPlayedWidgetScrollable.vue?vue&type=template&id=75c0d9a4&scoped=true"
import script from "./EventsBestPlayedWidgetScrollable.vue?vue&type=script&lang=js"
export * from "./EventsBestPlayedWidgetScrollable.vue?vue&type=script&lang=js"
import style0 from "./EventsBestPlayedWidgetScrollable.vue?vue&type=style&index=0&id=75c0d9a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0d9a4",
  null
  
)

export default component.exports